// extracted by mini-css-extract-plugin
export var quantityInput = "_gf-0";